import {
  Bell, CaretDown, ChartLineUp, GearSix, House, Package, SignOut, UsersThree,
} from '@phosphor-icons/react'
import { NavLink, Outlet } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '../auth/AuthContext'
import { FullPageState, QueryState } from './States'
import { StoreSetup } from './StoreSetup'
import { ForcePasswordModal } from './ForcePasswordModal'

const navigation = [
  { to: '/dashboard', label: '首页', icon: House },
  { to: '/inventory', label: '库存', icon: Package },
  { to: '/orders', label: '订单', icon: ChartLineUp },
  { to: '/customers', label: '客户', icon: UsersThree },
  { to: '/settings', label: '设置', icon: GearSix },
]

export function AppShell() {
  const { permissionInfo, stores, session, loading, contextError, logout, reloadContext, isTenantAdmin } = useAuth()
  const [accountOpen, setAccountOpen] = useState(false)
  if (loading) return <FullPageState title="正在准备经营工作台" />
  if (!session?.recoveryMode && !permissionInfo) {
    return <div className="full-state"><QueryState error={contextError || new Error('账号信息未就绪')} onRetry={reloadContext} /></div>
  }
  if (!session?.recoveryMode && stores && !stores.hasStore) {
    return <StoreSetup canCreate={stores.canCreateStore} onComplete={reloadContext} onLogout={logout} />
  }
  const user = permissionInfo?.user
  const userName = user?.nickname || user?.username || '当前账号'
  const avatar = user?.avatar?.trim()
  const avatarFallback = userName.trim().slice(0, 1).toLocaleUpperCase() || '用'
  return <div className="app-shell">
    <header className="lks-topbar">
      <NavLink className="lks-brand" to={session?.recoveryMode ? '/settings' : '/dashboard'} aria-label="乐客奢经营首页">
        <img className="lks-brand-logo" src="/assets/lekeshe-logo.png" alt="" width="42" height="42" />
        <span className="lks-brand-copy"><strong>乐客奢</strong><small>LEKESHE ERP</small></span>
      </NavLink>
      {!session?.recoveryMode && <nav className="lks-main-nav" aria-label="主导航">
        {navigation.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} className={({ isActive }) => `lks-nav-item${isActive ? ' is-active' : ''}`}>
          <Icon size={18} weight="regular" /><span>{label}</span>
        </NavLink>)}
      </nav>}
      <div className="lks-account">
        {!session?.recoveryMode && <button className="lks-notice-button" type="button" aria-label="消息"><Bell size={18} /><i aria-hidden="true" /></button>}
        <div className="lks-user">
          <button className="lks-account-trigger" type="button" onClick={() => setAccountOpen((value) => !value)} aria-haspopup="menu" aria-expanded={accountOpen}>
            {avatar
              ? <img className="lks-avatar" src={avatar} alt={`${userName}头像`} width="34" height="34" />
              : <span className="lks-avatar lks-avatar-fallback" role="img" aria-label={`${userName}默认头像`}>{avatarFallback}</span>}
            <span className="lks-user-copy"><strong>{userName}</strong><small>{session?.recoveryMode ? '系统恢复' : isTenantAdmin ? '老板' : '员工'}</small></span>
            <CaretDown className="lks-caret" size={12} />
          </button>
          {accountOpen && <div className="lks-account-menu" role="menu">
            <button type="button" role="menuitem" onClick={() => logout()}><SignOut size={17} /><span>退出登录</span></button>
          </div>}
        </div>
      </div>
    </header>
    <Outlet />
    <ForcePasswordModal />
  </div>
}
